import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Speaking', path: '/speaking' },
    { name: 'Book', path: '/book' },
    { name: 'Media Kit', path: '/media-kit' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo/Brand - Larger */}
          <Link to="/" className="flex items-center space-x-2">
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-charcoal">
              Ravi Prakash
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-safar-blue'
                    : 'text-gray-700 hover:text-safar-blue'
                }`}
              >
                {link.name}
              </Link>
            ))}
            {/* LinkedIn Icon */}
            <a
              href="https://www.linkedin.com/in/journeywithravi/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-safar-blue transition-colors"
              aria-label="LinkedIn Profile"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <Link to="/book-ravi" className="btn-primary">
              Book Ravi
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-gray-700" />
            ) : (
              <Menu className="h-6 w-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-sans font-medium transition-colors ${
                    isActive(link.path)
                      ? 'text-safar-blue'
                      : 'text-gray-700'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/book-ravi"
                onClick={() => setIsMenuOpen(false)}
                className="btn-primary text-center"
              >
                Book Ravi
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
